import Script from 'next/script';
import React, { useEffect, useState } from 'react';
import { useExperiment } from '@app/experiments';
import { config, EXPERIMENTS } from '@app/config';
import RoktLauncherContext from '../state/RoktLauncherContext';

const RoktLauncherProvider = ({ children }) => {
  const [launcher, setLauncher] = useState<any>(null);

  const abRoktAdsFlag = useExperiment(
    EXPERIMENTS.ab_growth_3p_ads_web,
  ) as string;

  const isRoktAdsEnabled = abRoktAdsFlag === 'true';

  const sandbox = config.ENVIRONMENT !== 'production';
  const accountId = config?.SERVICES.ROKT.ACCOUNT_ID;

  useEffect(() => {
    (async () => {
      if (!isRoktAdsEnabled) {
        return;
      }

      try {
        // Guards against Rokt script being still loaded into the application when the context is created
        await new Promise<Event | void>((resolve) => {
          if (window.Rokt) {
            resolve();
            return;
          }

          const roktElement = document.getElementById('rokt-launcher');

          if (roktElement !== null) {
            roktElement.onload = resolve;
          }
        });

        const launcherInstance = await window.Rokt.createLauncher({
          accountId,
          sandbox,
        });

        setLauncher(launcherInstance);
      } catch (e) {
        // do nothing
      }
    })();

    return () => {
      if (launcher) {
        try {
          launcher.terminate();
        } catch (e) {
          // do nothing
        }
      }
    };
  }, [accountId, sandbox]);

  if (!isRoktAdsEnabled) {
    return <>{children}</>;
  }

  // Return the context provider
  return (
    <>
      <Script
        async
        defer
        id="rokt-launcher"
        src="https://apps.rokt.com/wsdk/integrations/launcher.js"
        type="module"
      />
      <RoktLauncherContext.Provider value={launcher}>
        {children}
      </RoktLauncherContext.Provider>
    </>
  );
};

export default RoktLauncherProvider;
